/**
 * エスケープ字列変換
 *
 * @param  string
 * @return  置換後文字列
 */
/* eslint-disable */
const alterReplace = function (text, direction) {
  if (!text) {
    return ''
  }
  let replace_text = ''
  if (direction) {
    // エスケープ文字列を元に戻す
    replace_text = text.replace(/&cnm;/g, ',').replace(/&pipe;/g, '|')
  } else {
    // 文字をエスケープする
    replace_text = text.replace(/\,/g, '&cnm;').replace(/\|/g, '&pipe;')
  }
  return replace_text
}

export default alterReplace



// WEBPACK FOOTER //
// ./src/functions/alterStrReplace.js